<!-- Copyright (c) 2024 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="station-main">
    <Menus :menu="menus" @menuClicked="handleMenuClick"></Menus>
    <PopupEntry v-if="popupEntryShow" :show.sync="popupEntryShow" :title="titleStation" @save="saveStation"
      :requiredError="entryError" :errorMessages="errorMessage" :viewMode="viewMode"
      @requiredClicked="errorMessageClicked" :successMessages="successMessages" :updatedBy="updatedBy"
      :createdBy="createdBy">
      <Input placeholder="Station Code" :isDisabled="disableStationCode" :inputValue.sync="stationCode"
        :isRequired="true" validator="alphanumeric,10,uppercase" ref="stationCode"
        :errorMessage.sync="stationCodeError" />

      <Input placeholder="Station Description" :isDisabled="disableDescrpt" :inputValue.sync="stationDescription"
        :isRequired="true" ref="stationDescription" :errorMessage.sync="stationDescriptionError"
        validator="text,35,uppercase,alphanumeric,all" />

      <InputQuery 
      placeholder="State" 
      :isDisabled="disableState" 
      :items="StateList" 
      itemKey="State"
      :selectedObject.sync="selectedState" 
      ref="State"></InputQuery>

      <Input placeholder="Custom Department" 
      :isDisabled="disableCustomDepartment" 
      :inputValue.sync="CustomDepartment"
      ref="CustomDepartment" 
      :errorMessage.sync="CustomDepartmentError"
      validator="text,200,alphanumeric,all" />
    </PopupEntry>

    <div class="right-container">
      <TableBox title="Station" :tableData="stationList" :selectedRow.sync="selectedStation"></TableBox>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function () {
    return {
      menus: [
        {
          title: "New Station",
          icon:
            "https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png",
          key: "MnuNew",
          visible: true,
          enabled: true
        },
        {
          title: "Edit Station",
          icon:
            "https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png",
          key: "MnuEdit",
          visible: true,
          enabled: true
        },
        {
          title: "Delete Station",
          icon:
            "https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png",
          key: "MnuDelete",
          visible: false,
          enabled: true
        },
        {
          title: "View Station",
          icon:
            "https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png",
          key: "MnuQuery",
          visible: true,
          enabled: true
        }
      ],
      // data from API GET
      stationCode: "",
      stationDescription: "",
      CustomDepartment: "",
      createdBy: "",
      updatedBy: "",

      popupEntryShow: false,
      titleStation: "",
      disableDescrpt: false,
      disableStationCode: false,
      disableCustomDepartment: false,
      entryError: [],
      errorMessage: [],
      successMessages: [],
      viewMode: false,
      saveOption: "",
      // Row selected from table
      selectedStation: [],
      // Data fetched from API to display in the table
      stationList: [],
      StateList: [],
      selectedState: null,
      // Error Messages
      stationDescriptionError: "",
      stationCodeError: "",
      CustomDepartmentError: "",
    };
  },
  methods: {
    errorMessageClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },

    clearErrorMessages: function () {
      this.stationDescriptionError = "";
      this.stationCodeError = "";
      this.CustomDepartmentError = "";
    },

    getSpecificStation: async function (record) {
      this.$fullscreenLoading("Getting Details");
      let details = (
        await this.$apiCallV2(`/Master/GetDetailsMaster`, {
          masterfile: "STATION",
          recordid: record
        })
      )["Station"];
      this.stationCode = details["StationCode"];
      this.stationDescription = details["StationDescription"];
      this.selectedState = this.StateList.getSelected(
        details["State"],
        "State"
      );
      this.CustomDepartment = details["CustomDepartment"];
      this.createdBy = `${details["UserCreated"] || ""} ${details["TimeCreated"]
          ? new Date(details["TimeCreated"]).formatString("dd/MM/yyyy HH:mm")
          : ""
        }`;
      this.updatedBy = `${details["UserID"] || ""} ${details["DateUpdated"]
          ? new Date(details["DateUpdated"]).formatString("dd/MM/yyyy HH:mm")
          : ""
        }`;
      this.$fullscreenLoading();
    },
    getStateList: async function () {
      this.$fullscreenLoading("Getting State");
      this.StateList = await this.$apiCallV2("/Master/GetListMaster", {
        masterfile: "STATION_STATE"
      });
      this.$fullscreenLoading();
    },
    getAllStationDetails: async function () {
      this.$fullscreenLoading("Getting Station");
      this.stationList = [];
      this.stationList = await this.$apiCallV2("/Master/GetListMaster", {
        masterfile: "STATION"
      });
      this.$fullscreenLoading();
    },
    clearInputFields: function () {
      this.stationCode = "";
      this.stationDescription = "";
      this.CustomDepartment = "",
      this.selectedState = null;
      this.createdBy = "";
      this.updatedBy = "";
    },
    handleMenuClick: async function (menu) {
      this.errorMessage = [];
      this.entryError = [];
      this.successMessages = [];
      this.clearErrorMessages();

      switch (menu.title) {
        case "View Station":
          if (this.selectedStation.length == 0) {
            this.$showAlert(
              "error",
              "No Station Selected",
              "Please select a record to view"
            );
          } else {
            await this.getSpecificStation(
              this.selectedStation[0]["Station Code"]
            );
            this.disableDescrpt = true;
            this.disableStationCode = true;
            this.disableState = true;
            this.disableCustomDepartment = true;
            this.viewMode = true;
            this.titleStation = "View Station";
            this.popupEntryShow = true;
          }
          break;
        case "Edit Station":
          if (this.selectedStation.length == 0) {
            this.$showAlert(
              "error",
              "No Station Selected",
              "Please select a record to edit"
            );
          } else {
            await this.getSpecificStation(
              this.selectedStation[0]["Station Code"]
            );

            this.saveOption = "E";
            this.disableDescrpt = false;
            this.disableStationCode = true;
            this.disableState = false;
            this.disableCustomDepartment = false;
            this.viewMode = false;
            this.titleStation = "Edit Station";
            this.popupEntryShow = true;
          }
          break;
        case "New Station":
          this.clearInputFields();
          this.saveOption = "N";
          this.disableDescrpt = false;
          this.disableStationCode = false;
          this.disableState = false;
          this.disableCustomDepartment = false;
          this.viewMode = false;
          this.titleStation = "New Station";
          this.popupEntryShow = true;
          break;
        case "Delete Station":
          if (!this.selectedStation.length) {
            this.$showAlert(
              "error",
              "No Station Selected",
              "Please select a record to delete"
            );
            return;
          }
          let deleting = await this.$showAlert(
            "warning",
            "Delete Station",
            `Are you sure you want to delete Station Code ${this.selectedStation[0]["Station Code"]
            }?`,
            [
              { text: "Delete", textColor: "white", color: "red" },
              { text: "Cancel", textColor: "black", color: "lightgray" }
            ]
          );

          if (deleting == "Cancel") {
            return;
          }

          this.$fullscreenLoading("Deleting Station");
          let result = await this.$apiCallV2("/Station/SaveStation", {
            action: "D",
            stationcode: this.selectedStation[0]["Station Code"]
          });
          this.$fullscreenLoading();
          if (result[0]["Results"] == 0) {
            this.$showAlert(
              "success",
              "Station Code Deleted",
              `Successfully deleted Station Code ${this.selectedStation[0]["Station Code"]
              }`
            );
            this.$nextTick(async () => await this.getAllStationDetails());
            this.selectedStation = [];
            return;
          }
          this.$showAlert(
            "error",
            "Station NOT Deleted",
            `There was an error deleting Station Code: ${this.selectedStation[0]["Station Code"]
            }`
          );

          break;
      }
    },
    saveStation: async function () {
      this.entryError = [];
      this.errorMessage = [];
      let isValid = this.checkFields();
      if (isValid) {
        let dataToPost = {
          stationcode: this.stationCode,
          stationdescription: this.stationDescription,
          state: this.selectedState ? this.selectedState.State : '',
          customdepartment: this.CustomDepartment,
          action: this.saveOption
        };

        this.$fullscreenLoading("Saving Station");
        let postUpdate = await this.$apiCallV2(
          "/Station/SaveStation",
          dataToPost
        );
        this.$fullscreenLoading();

        if (postUpdate[0].Results >= 1) {
          this.errorMessage.push(postUpdate[0].ErrMsg);
        } else {
          if (this.saveOption == "N") {
            this.successMessages.push(
              "Successfully created Station Code: " + this.stationCode
            );
          }
          if (this.saveOption == "E") {
            this.successMessages.push(
              "Successfully edited Station Code: " + this.stationCode
            );
          }
          this.viewMode = true;
          this.disableDescrpt = true;
          this.disableStationCode = true;
          this.disableState = true;
          this.disableCustomDepartment = true;
          this.titleStation = "View Station";
          this.getAllStationDetails();
        }
      }
    },
    checkFields: function() {
      this.clearErrorMessages();
      let isValid = true;

      if (!this.stationDescription || !this.stationDescription.trim()) {
        this.stationDescriptionError = 'Station Description is required!';
        this.entryError.push({ key: "stationDescription", value: this.stationDescriptionError });
        isValid = false;
      }
      if (this.stationDescription.trim().length > 35) {
        this.stationDescriptionError = 'Station Description cannot exceed 35 characters!';
        this.entryError.push({ key: "stationDescription", value: this.stationDescriptionError });
        isValid = false;
      }
      if (!this.stationCode || !this.stationCode.trim()) {
        this.stationCodeError = 'Station Code is required!';
        this.entryError.push({ key: "stationCode", value: this.stationCodeError });
        isValid = false;
      } 
      if (this.stationCode.trim().length > 10) {
        this.stationCodeError = 'Station Code cannot exceed 10 characters!';
        this.entryError.push({ key: "stationCode", value: this.stationCodeError });
        isValid = false;
      } 
      if (this.CustomDepartment.trim().length > 200) {
        this.CustomDepartmentError = 'Custom Department cannot exceed 200 characters!';
        this.entryError.push({ key: "CustomDepartment", value: this.CustomDepartmentError });
      }
      return isValid;
    }
  },
  mounted() {
    this.$bus.$on("pageSASControlAccess", x => {
      if (x.page == "Station") {
        x.data.forEach(k => {
          let selectedMenu = this.menus.find(m => m["key"] == k["Control"]);
          if (selectedMenu) {
            selectedMenu[k["Properties"].toLowerCase()] =
              k["PropertiesValue"] == "True";
          }
        });
      }
    });
    this.getStateList();
    this.getAllStationDetails();
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
@import "@/css/all.scss";
.station-main {
  padding: 10px 45px;
  font-size: 12px;
  display: flex;

  >.right-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
  }
}
</style>